import { format } from 'date-fns';

// Format date
export const formatDate = (date) => {
  if (!date) return 'N/A';
  return format(new Date(date), 'MMM dd, yyyy HH:mm');
};

// Format currency
export const formatCurrency = (amount) => {
  if (!amount) return '₦0';
  return `₦${Number(amount).toLocaleString()}`;
};

// Truncate text
export const truncateText = (text, length = 50) => {
  if (!text) return '';
  return text.length > length ? `${text.substring(0, length)}...` : text;
};

// Get status badge color
export const getStatusColor = (status) => {
  const statusMap = {
    pending: 'badge-pending',
    approved: 'badge-approved',
    rejected: 'badge-rejected',
    completed: 'badge-completed',
    active: 'badge-approved',
    inactive: 'badge-rejected',
    resolved: 'badge-approved',
  };
  return statusMap[status?.toLowerCase()] || 'badge-pending';
};

// Get status label
export const getStatusLabel = (status) => {
  if (!status) return 'Pending';
  return status.charAt(0).toUpperCase() + status.slice(1);
};

// Get action button styles
export const getActionButtonStyles = (type) => {
  const styles = {
    view: 'p-1.5 rounded-lg text-blue-600 hover:bg-blue-50 transition-colors',
    approve: 'p-1.5 rounded-lg text-green-600 hover:bg-green-50 transition-colors',
    reject: 'p-1.5 rounded-lg text-red-600 hover:bg-red-50 transition-colors',
    delete: 'p-1.5 rounded-lg text-gray-600 hover:bg-gray-50 transition-colors',
    resolve: 'p-1.5 rounded-lg text-green-600 hover:bg-green-50 transition-colors',
  };
  return styles[type] || styles.view;
};

// Get responsive button classes
export const getResponsiveButtonClasses = (variant = 'primary') => {
  const base = 'inline-flex items-center justify-center gap-2 px-3 py-1.5 text-xs sm:text-sm font-medium rounded-lg transition-all duration-200';
  
  const variants = {
    primary: 'bg-primary-600 text-white hover:bg-primary-700 hover:shadow-md active:scale-95',
    success: 'bg-green-600 text-white hover:bg-green-700 hover:shadow-md active:scale-95',
    danger: 'bg-red-600 text-white hover:bg-red-700 hover:shadow-md active:scale-95',
    warning: 'bg-yellow-600 text-white hover:bg-yellow-700 hover:shadow-md active:scale-95',
    outline: 'border-2 border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400 active:scale-95',
  };
  
  return `${base} ${variants[variant] || variants.primary}`;
};